import poster from '@/static/assets/reviews/DawnRado/video.jpg';
import subs from '@/static/assets/reviews/DawnRado/subs.vtt';
import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';

export const DawnRado: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Dawn',
  videoUrl: `${ASSETS_URL}/pet/DawnRado_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
